<template>
  <div class="main">
    <a-row class="h-full w-full" >
      <a-col :xs="0" :sm="0" :md="10" :lg="8" :xl="8" class="h-full" >
        <div class="left h-full" >
          <div class="font-40 font-bold color-white" ><span class="text-color-gradient" >天能电池</span>管理后台</div>
          <div class="m-t-32 font-20 color-white"  >Hi,欢迎使用本平台~</div>
        </div>
      </a-col>
      <a-col :xs="24" :sm="24" :md="14" :lg="16" :xl="16" class="h-full" >
        <a-row class="w-full h-full" >
          <a-col :xs="2" :sm="2" :md="4" :lg="7" :xl="8"></a-col>
          <a-col :xs="20" :sm="20" :md="16" :lg="10" :xl="8" class="h-full" >
            <tk-flex middle center column class="right h-full p-b-32 w-full" >
              <a href="/">
                <img src="../../assets/images/logo.png" class="logo" alt="logo" />
              </a>
              <!-- <div class="font-24 w-full" style="color: #202224; margin-top: 60px;" >登录</div> -->
              <a-form id="formLogin" class="user-layout-login w-full" style="margin-top: 50px;">
                <a-form-item class="m-t-32 w-full">
                  <a-input size="large" type="text" placeholder="账户" v-model="username">
                    <!-- <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" /> -->
                  </a-input>
                </a-form-item>

                <a-form-item>
                  <a-input
                    size="large"
                    type="password"
                    autocomplete="false"
                    placeholder="密码"
                    v-model="password"
                  >
                    <!-- <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" /> -->
                  </a-input>
                </a-form-item>

                <a-form-item class="m-b-32 w-full" style="margin-top:60px">
                  <button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    class="login-button w-full font-14"
                    :loading="loading"
                    @click="login"
                  >登录</button>
                </a-form-item>
              </a-form>
            </tk-flex>
          </a-col>
          <a-col :xs="2" :sm="2" :md="4" :lg="7" :xl="8"></a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>

</template>

<script>
import './login.scss'
import store from '../../store'
import superPer from '../../core/permissions.yaml'
export default {
  layout: 'user',
  data () {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  mounted () {
  },
  methods: {
    async login () {
      if (!this.username || !this.password) {
        this.$notification['error']({
          message: '错误',
          description: '请填写账号和密码'
        })
        return
      }
      this.loading = true
      try {
        let res = await this.$tkParse.post('/login', {
          username: this.username,
          password: this.password
        })
        this.$tkParse.setSessionToken(res.data.sessionToken)
        let user = await this.$tkParse.getData('/users/me')
        let { data: userData } = await this.$tkParse.get(`/classes/_User/${user.objectId}`)
        user = Object.assign(user, userData)
        // 判断用户身份
        // if (!user.adminRole) throw new Error('not admin')
        if (!user.adminRole) {
          this.loading = false
          this.$notification['error']({
            message: '错误',
            description: '您没有权限登录'
          })
          return this.$store.commit('setSessionToken', null)
        }
        // 子账号
        if (user.adminRole === 'admin') {
          if (user.authority.length) {
            store.commit('setAuth', user.authority)
          } else {
            this.loading = false
            this.$notification['error']({
              message: '错误',
              description: '该账号暂未分配权限'
            })
            return this.$store.commit('setSessionToken', null)
          }
        }
        // 普通判断
        if (user.adminRole === 'staff' && user.department) {
          let auth = await this.$tkParse.getData(`/classes/department/${user.department}`)
          if (auth.authority.length === 0) {
            this.loading = false
            this.$notification['error']({
              message: '错误',
              description: '该账号暂未分配权限'
            })
            return this.$store.commit('setSessionToken', null)
          }
          store.commit('setAuth', auth.authority)
        }
        /// 超管判断
        if (user && user.adminRole && user.adminRole === 'superAdmin') {
          // 把superPer数组中的children的key放入一个数组中 使用map方法
          let arr = superPer.map(item => {
            return item.children.map(item => {
              return item.key
            })
          })
          // 把数组中的数组合并成一个数组
          arr = [].concat.apply([], arr)
          store.commit('setAuth', arr)
        }
        // 判断用户是否被删除
        if (user.isDelete === true) {
          this.loading = false
          this.$notification['error']({
            message: '错误',
            description: '该账号已被删除'
          })
          return this.$store.commit('setSessionToken', null)
        }
        // 判断用户是否被禁用
        if (user.isEnable === false) {
          this.loading = false
          this.$notification['error']({
            message: '错误',
            description: '该账号已被禁用'
          })
          return this.$store.commit('setSessionToken', null)
        }
        this.$store.commit('setUser', user)
        this.$store.dispatch('initUser', {})
        this.$store.commit('setSessionToken', res.data.sessionToken)
        this.$router.push('/')
      } catch (e) {
        this.$notification['error']({
          message: '无法登录',
          description: '账号或密码错误'
        })
        this.$tkParse.setSessionToken(null)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
